import { Injectable } from "@angular/core";
import { ColDef, ColGroupDef, GridApi, GridReadyEvent } from "ag-grid-community";
import { Subject } from "rxjs";
import { ACTIONS_COL_ID } from "../components/grid/grid.component";

@Injectable({
    providedIn: "root"
})
export class GridService {
    private gridApi: GridApi;
    public gridReady$ = new Subject<void>();

    public init(params: GridReadyEvent): void {
        this.gridApi = params.api;
        this.gridReady$.next();
    }

    public setSelectedCheckboxes(nodesToSet: Array<{ id: string; checked: boolean }>, idPropertyOnRow: string): void {
        this.gridApi.getRenderedNodes().forEach((node) => {
            const nodeId = node.data?.[idPropertyOnRow];
            const nodeSelection = nodesToSet.find((x) => x.id === nodeId);

            if (nodeSelection) node.setSelected(nodeSelection.checked);
        });
    }

    public setColumnDefsAndResize(colDefs: Array<ColDef | ColGroupDef>): void {
        this.gridApi?.setGridOption("columnDefs", colDefs);
        this.gridApi?.sizeColumnsToFit();
        this.gridApi?.autoSizeColumns([ACTIONS_COL_ID]);
    }

    public selectRange(key: string, values: Array<any>): void {
        this.gridApi?.forEachNode((n) => {
            if (values.includes(n.data[key])) {
                n.setSelected(true);
            }
        });
    }

    public clearSelected(): void {
        this.gridApi?.forEachNode((n) => n.id && n.setSelected(false));
    }
}
